import React, { useEffect, useRef, useState } from 'react';
import { formatLanguageDisplay } from '../../utils/roadmapDisplay';
import IconRenderer from '../ui/IconRenderer';
import { normalizeSnippetTitle } from './playgroundSnippets';

const PlaygroundSaveSnippetDialog = ({
  open,
  mode = 'new',
  initialTitle,
  language,
  codePreview,
  onCancel,
  onConfirm,
}) => {
  const inputRef = useRef(null);
  const [title, setTitle] = useState(initialTitle || '');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setTitle(initialTitle || '');
    setError('');
    const timer = setTimeout(() => {
      inputRef.current?.focus();
      inputRef.current?.select();
    }, 0);
    return () => clearTimeout(timer);
  }, [open, initialTitle]);

  if (!open) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm(normalizeSnippetTitle(title));
  };

  const isRename = mode === 'rename';
  const heading = isRename ? 'Rename snippet' : 'Save snippet';
  const submitLabel = isRename ? 'Save name' : 'Save snippet';

  return (
    <div
      className="playground-save-snippet-dialog__overlay"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="playground-save-snippet-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="playground-save-snippet-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="playground-save-snippet-dialog__header">
          <h2 id="playground-save-snippet-dialog-title" className="playground-save-snippet-dialog__title">
            {heading}
          </h2>
          <button
            type="button"
            className="playground-save-snippet-dialog__close"
            onClick={onCancel}
            aria-label="Close"
          >
            ×
          </button>
        </header>

        <form className="playground-save-snippet-dialog__body" onSubmit={handleSubmit}>
          <label className="playground-save-snippet-dialog__label" htmlFor="playground-snippet-name">
            Snippet name
          </label>
          <input
            ref={inputRef}
            id="playground-snippet-name"
            type="text"
            className="playground-save-snippet-dialog__input"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
              if (error) setError('');
            }}
            placeholder="e.g. factorial, quick_sort"
            maxLength={80}
            autoComplete="off"
          />
          {error && (
            <p className="playground-save-snippet-dialog__error" role="alert">
              {error}
            </p>
          )}

          <div className="playground-save-snippet-dialog__meta">
            <span className="playground-save-snippet-dialog__meta-chip">
              <IconRenderer
                type="language"
                name={language}
                className="playground-save-snippet-dialog__meta-icon"
              />
              {formatLanguageDisplay(language)}
            </span>
            {codePreview && (
              <code className="playground-save-snippet-dialog__preview" title={codePreview}>
                {codePreview}
              </code>
            )}
          </div>

          <div className="playground-save-snippet-dialog__actions">
            <button
              type="button"
              className="playground-save-snippet-dialog__btn playground-save-snippet-dialog__btn--ghost"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="playground-save-snippet-dialog__btn playground-save-snippet-dialog__btn--primary"
            >
              {submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlaygroundSaveSnippetDialog;
